/**
 * What "running" means for agents, in one place: the nav badge, the overview count and the
 * Agents page all count with these, so they never disagree.
 */
import type { RunStatus, Session, WorkflowAgent, WorkflowRun } from '@orgus/protocol';

/** An agent's status as shown: when its workflow has ended, an agent still marked running has stopped. */
export function agentStatus(w: Pick<WorkflowRun, 'status'>, a: Pick<WorkflowAgent, 'status'>): RunStatus {
  return a.status === 'running' && w.status !== 'running' ? 'stopped' : a.status;
}

/**
 * Running work in one session. A running subagent is one. A workflow is its running agents,
 * or itself (one) while it runs and its machine lists no agents yet.
 */
export function runningUnits(s: Pick<Session, 'subagents' | 'workflows'>): number {
  let n = 0;
  for (const a of s.subagents) if (a.status === 'running') n++;
  for (const w of s.workflows) {
    if (w.agents?.length) {
      for (const a of w.agents) if (agentStatus(w, a) === 'running') n++;
    } else if (w.status === 'running') n++;
  }
  return n;
}
